/** @format */

import {memo, ReactNode} from 'react';

import {SxProps} from '@mui/material';

import {StyledTableCell} from './styles';
import {TableVariant} from '../../types';

interface Props {
  width?: number;
  height?: number;
  sorted?: boolean;
  children?: ReactNode;
  sx?: SxProps;
  colSpan?: number;
  rowSpan?: number;
  cellHeight: number;
  enableHoverExpand?: boolean;
  isExpandable?: boolean;
  isWithSubRows?: boolean;
  canSort?: boolean;
  tableVariant?: TableVariant;
  verticalAlign?: 'top' | 'middle';
  // Ширину колонки задаёт <col> из <colgroup>: ячейка не получает ни ширины в стилях,
  // ни HTML-атрибута width.
  isWidthFromColgroup?: boolean;
}

const TableCellNoMemo = ({children, width, isWidthFromColgroup, ...restProps}: Props) => {
  return (
    <StyledTableCell
      {...restProps}
      isWidthFromColgroup={isWidthFromColgroup}
      // Флаг сам гасит ширину, а не надеется на дисциплину вызывающего: иначе число долетело бы
      // до DOM как HTML-атрибут width, и под table-layout: fixed браузер взял бы максимум из
      // ширины <col> и ширины ячейки первой строки — колонка перестала бы сужаться за драгом.
      width={isWidthFromColgroup ? undefined : width}
    >
      {children}
    </StyledTableCell>
  );
};

const TableCellMemoized = memo(TableCellNoMemo);

export {TableCellMemoized};
